import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'sr',
    fullName: 'Serbian',
    nativeName: 'Српски',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "АргВоид",
    landing_title: "Нешто невероватно долази",
    landing_subtitle: "АргВоид је студио за развој апликација и игара. Останите са нама, ускоро стижу нове ствари!",
    select_language: "Изаберите Језик",
    search_placeholder: "Претражи језике...",
    terms_title: "Услови коришћења услуге",
    policy_title: "Политика приватности",
    cookies_title: "Политика колачића",
    terms_content: `
        Кс0Кс1. Прихватање условаКс1КСКС2Кс
        Приступањем АргВоид-у, прихватају се ови Услови коришћења услуге. Ако се ови услови не слажу, услуга се не би требало користити.Кс3КСКС4Кс

        Кс5Кс2. Употреба платформеКс6КСКС7Кс
        АргВоид и његове апликације се пружају „као што јесу“ у информативне и креативне сврхе. Услуга се мора користити само у законите сврхе.Кс8КСКС9Кс

        Кс10Кс3. Забрањено понашањеКс11КСКС12Кс
        Искоришћавање рањивости сајта, слање нежељене поште или покушај неовлашћеног приступа инфраструктури је строго забрањено.Кс13КСКС14Кс

        Кс15Кс4. ДисцлаимерКс16КСКС17Кс
        Платформа и услуге могу бити измењене у било ком тренутку без претходне најаве. Не даје се гаранција у вези са трајањем или доступношћу услуге.
    `,
    policy_content: `
        Кс0Кс1. Збирка информацијаКс1КСКС2Кс
        Платформа тренутно не захтева аутентификацију корисника или креирање налога. Никакве личне идентификационе информације (као што су имена или адресе е-поште) се активно не прикупљају од посетилаца.Кс3КСКС4Кс

        Кс5Кс2. Усаге ДатаКс6КСКС7Кс
        Основна, анонимна аналитика се може прикупити да би се разумео саобраћај на сајту и побољшале апликације. Ови подаци нису повезани са индивидуалним корисничким идентитетима.Кс8КСКС9Кс

        Кс10Кс3. Услуге трећих странаКс11КСКС12Кс
        Провајдери трећих страна могу се користити за услуге хостовања и аналитике. Пракса приватности ових одговарајућих провајдера регулише анонимне податке који се обрађују на њиховој инфраструктури.Кс13КСКС14Кс

        Кс15Кс4. Дата СецуритиКс16КСКС17Кс
        Спроводе се разумне мере безбедности ради заштите платформе. Међутим, ниједан метод преноса преко Интернета није у потпуности безбедан.Кс18КСКС19Кс
    `,
    cookies_content: `
        Кс0Кс1. Шта су колачићи и локално складиште?Кс1КСКС2Кс
        Колачићи и локална меморија претраживача су мале датотеке са подацима ускладиштене на уређају да би запамтиле подешавања конфигурације током посета.Кс3КСКС4Кс

        Кс5Кс2. Сврха употребеКс6КСКС7Кс
        Претраживач ЛоцалСтораге се користи искључиво за чување подешавања конфигурације, као што је: Кс8Кс
        - Преференце језикаКс9Кс
        - Конфигурација корисничког интерфејса (нпр. подешавања изгледа или теме) Кс10Кс
        - Привремени кеш апликацијеКс11КСКС12Кс

        Кс13Кс3. Нема праћењаКс14КСКС15Кс
        Колачићи и локално складиште се не користе у сврхе оглашавања или праћења треће стране. Сви сачувани подаци су искључиво за основну функционалност платформе.Кс16КСКС17Кс

        Кс18Кс4. ЦонтролКс19КСКС20Кс
        Подаци претраживача могу да се обришу у било ком тренутку кроз подешавања претраживача, што ће ресетовати све локалне конфигурације.
    `,
    cookie_consent_text: "Користимо основне колачиће да бисмо обезбедили да веб локација правилно функционише, као што је одржавање ваше сесије активном, чување ваших језичких поставки и друге прилагођене конфигурације.",
    read_policy: "Прочитајте политику колачића",
    support_title: "Контактирајте подршку",
    support_subject_label: "Предмет",
    support_message_label: "Порука",
    support_submit_button: "Пошаљи поруку",
    support_hint: "Напомена: Ово ће отворити вашу подразумевану апликацију за е-пошту за слање поруке.",
    support_success_msg: "Отвара се ваша апликација за е-пошту...",
    support_error_msg: "Слање поруке није успело. Покушајте поново касније.",
    explorer_title: "Екплорер",
    history_title: "Историја",
    animation_title: "Анимација",
    config_title: "Конфигурација",
    tool_mouse: "Изаберите (Цтрл+М)",
    tool_brush: "Четка (Цтрл+Б)",
    tool_brush_mode: "Пребаци режим (чврсто/јасно)",
    tool_eraser: "Гумица (Цтрл+Е)",
    tool_brush_size: "Подесите величину четкице",
    tool_bucket: "Попуна (Цтрл+Ф)",
    tool_eyedropper: "Капаљка за очи",
    tool_grid: "Мрежа (Цтрл+Схифт+Б)",
    tool_rotate: "Ротирајте (Цтрл+Схифт+Р)",
    tool_flip_h: "Окрените Х (Цтрл+Схифт+Х)",
    tool_flip_v: "Окрените В (Цтрл+Схифт+В)",
    tool_transpose: "Транспоновање (Цтрл+Схифт+Т)",
    label_width: "Ширина",
    label_height: "Висина",
    label_frames: "Број оквира",
    label_animation: "Аниматион Стиле",
    label_background_color: "Боја позадине",
    label_interval: "Интервал",
    tool_anim_config: "Конфигурација анимације",
    label_new_width: "Нова ширина",
    label_new_height: "Нова висина",
    label_apply: "Пријавите се",
    label_colors: "Боје",
    label_size: "Величина",
    label_tolerance: "Толеранција",
    val_horizontal: "Хоризонтално",
    val_vertical: "Вертицал",
    val_sequence: "Секуенце",
    val_bounce: "Боунце",
    val_random: "Рандом",
    val_solid: "Чврсто",
    val_clear: "Јасно",
    action_add_sheet: "Нев Схеет",
    action_import: "Увоз",
    action_export: "Извоз",
    action_sort_projects: "Сортирај",
    sort_date_old: "Прво најстарији",
    sort_date_new: "Најновије прво",
    sort_name_az: "Име (А-З)",
    sort_name_za: "Име (З-А)",
    action_new_sprite: "Нев Сприте",
    action_new_project: "Нови пројекат",
    modal_save_all_title: "Сачувај све промене",
    modal_save_all_desc: "Изаберите средства за чување:",
    modal_save_selected: "Сачувај изабрано",
    action_saved: "Сачувано",
    modal_create_sprite_title: "Креирајте нови Сприте",
    modal_create_project_title: "Креирајте нови пројекат",
    modal_add_sheet_title: "Додај нови лист",
    modal_rename_sheet_title: "Преименуј лист",
    modal_rename_sprite_title: "Преименуј Сприте",
    modal_delete_sprite_title: "Избриши Сприте",
    modal_delete_project_title: "Избриши пројекат",
    modal_delete_sheet_title: "Избриши лист",
    placeholder_sprite_name: "Име",
    placeholder_project_name: "Име",
    placeholder_sheet_name: "Име",
    placeholder_new_name: "Ново име",
    action_create: "Креирај",
    action_add: "Додај",
    action_rename: "Преименуј",
    action_duplicate: "Дупликат",
    action_delete: "Избриши",
    action_cancel: "Откажи",
    confirm_delete_sprite: "Да ли сте сигурни да желите да избришете овај срајт?",
    confirm_delete_project: "Да ли сте сигурни да желите да избришете овај пројекат? Сви спрајтови ће бити уклоњени.",
    confirm_delete_sheet: "Да ли сте сигурни да желите да избришете овај лист?",
    err_select_sprite: "Прво изаберите сприте.",
    err_select_project: "Прво изаберите пројекат.",
    err_name_empty: "Име не може бити празно.",
    err_sprite_exists: "Спрајт са тим именом већ постоји.",
    err_project_exists: "Пројекат са тим именом већ постоји.",
    err_no_content: "Нема садржаја за чување.",
    err_no_changes: "Нема промена за чување.",
    err_delete_last_sheet: "Није могуће избрисати последњи лист.",
    err_extract_frames: "Није могуће издвојити ниједан оквир.",
    err_indexeddb: "Локално чување није успело. Ваш претраживач можда не подржава ИндекедДБ.",
    msg_upload_success: "Отпремање успешно: {0}",
    msg_upload_failed: "Отпремање није успело: {0}",
    msg_save_success: "Чување успешно.",
    msg_saving: "Чување...",
    msg_multi_save_result: "Сачувано {0} средстава. {1} грешака.",
    menu_title: "Мени",
    menu_save: "Сачувај",
    menu_save_all: "Сачувај све",
    menu_support: "Контактирајте подршку",
    label_local_storage: "Локално складиште",
    label_sign_in: "Пријавите се",
    modal_export_title: "Извези Сприте",
    label_filename: "Име датотеке",
    label_format: "Формат",
    action_export_confirm: "Извоз",
};

export default translations;
